import axios, { AxiosError } from 'axios';

// const baseUrl = 'http://localhost:8080';
const baseUrl = 'https://api.bancadoingresso.com.br';
const prefixBaseUrl = '/api/biometric/';

const api = axios.create({
  baseURL: `${baseUrl}${prefixBaseUrl}`,
  responseType: 'json',
});

export { api, AxiosError };
